import { useState, useEffect } from "react";
import PatrolsService from "../../services/patrols.service";
import styles from "./Patrolmeter.module.css";
import ScreenHeader from "../../components/ScreenHeader/ScreenHeader";

export default function PatrullometroAzimut() {
  const [patrols, setPatrols] = useState([]);
  const [leaderPoints, setLeaderPoints] = useState(0);

  useEffect(() => {
    const fetchPatrols = async () => {
      const response = await PatrolsService.getPatrols();

      setPatrols(response.data);
      setLeaderPoints(Math.max(...response.data.map((p) => p.score)));
    };

    fetchPatrols();
  }, []);
  return (
    <main className={styles.app}>
      <section className={styles.container}>
        <ScreenHeader title="Patrullómetro Impeesa" showMenu={false} />

        <ul className={styles.scoreboard}>
          {patrols.map((patrol) => {
            const isLeader = patrol.score === leaderPoints;

            return (
              <li
                key={patrol.name}
                className={`${styles.patrol} ${isLeader ? styles.leader : ""}`}
              >
                <div className={styles.colors}>
                  <span style={{ background: patrol.colors[0] }} />
                  <span style={{ background: patrol.colors[1] }} />
                </div>

                <div className={styles.content}>
                  <img
                    src={patrol.crest}
                    alt={`Escudo ${patrol.name}`}
                    className={styles.crest}
                  />

                  <span className={styles.name}>{patrol.name}</span>

                  <span className={styles.points}>{patrol.score}</span>
                </div>
              </li>
            );
          })}
        </ul>
      </section>
    </main>
  );
}
